module.exports = __webpack_public_path__ + "resources/icon_yello_v.1ad24afb4f2abe1a.png";